import React, {createContext, useContext} from "react";
import {Dialog as GenericDialog, GenericDialogProps} from "../../../../dialog";
import QCPopUpContent from "./Content";
import {Button} from "../../../../formInputs";
import {PolicyContextProvider, usePolicyContext} from "../../../../clientServicing/Payments/PolicyContext";
import EpayRejectPayment from "../../../../EpayRejectPayment";
import {useActions} from "../../../../../actions";
import * as EnrollmentActions from "../../../../../actions/enrollment";
import * as PaymentActions from "../../../../../actions/payment";
import { PaymentProcess } from "../../../../../constants";
import {
    epayRejectedDropdown
} from "../../../../../pages/client/Enrollment/EnrollmentHome/basicInfo/PersonalDetailUtils";
import {createStyles, Grid, makeStyles} from "@material-ui/core";
import {useDispatch} from "react-redux";

export interface QCPopUpProps {
    actionPayload?: any,
    setOpenPopup: Function,
    openPopup: boolean,
    enrollmentId?: string
    client?: any
    refreshList?:Function,
    clientPolicy?: any,
    actionType?: string
}

export const QcPopUpContext = createContext<{
    client?:any,
    enrollmentId?: string,
    setOpenPopup: Function
    refreshList?:Function,
    setSubmitting?: Function,
    clientPolicy?: any
    actionType?:string
}>({setOpenPopup: Function })

export default function QCPopUp(props: QCPopUpProps) {
    const { openPopup, setOpenPopup, client, enrollmentId, refreshList, clientPolicy, actionType, actionPayload } = props;
    const [epayShowRp, epaySetRp] = React.useState(false);
    const [submitting, setSubmitting] = React.useState(false)
    const handleClose = () => {
        setOpenPopup(false);
    };

    const useStyles = makeStyles(()=>
    createStyles(
        {
            buttonFormatting:{
                display:"flex",
                gap:"2px"
            }
        }
    )
    )

    const classes = useStyles();

    const dialogProps: GenericDialogProps = {
        actions: (
                <Grid className={classes.buttonFormatting}>

                    <Button
                            label={"Reject Payment"}
                            type="button"
                            variant="contained"
                            color="primary"
                            onClick={() => {
                                // setOpenPopup(false);
                                epaySetRp(true)
                            }}
                            disabled={submitting}
                            className="btnContainedRed"
                    />
                    <Button
                            label={"Accept"}
                            type="submit"
                            variant="contained"
                            form={"QCEpayForm"}
                            disabled={submitting}
                            // onClick={() => setOpenPopup(false)}
                            color="primary"
                            className="floatLeft floatRightSM mb15"
                    />
                </Grid>
        ),
        "aria-labelledby": "upload_proposal-pop-up-form-dialog-title",
        fullWidth: true,
        maxWidth: "md",
        content: (<PolicyContextProvider clientData={{
            name: client.user.firstName + " " + client.user.lastName,
            email: client.user.email,
            clientPolicy: clientPolicy,
            ...client,
        }}>
            <QcPopUpContext.Provider
                    value={{ client, enrollmentId, setOpenPopup, refreshList, setSubmitting, clientPolicy, actionType }}>
                <QCPopUpContent actionPayload={actionPayload}>
                    <PopUp epaySetRp={epaySetRp} epayShowRp={epayShowRp} />
                </QCPopUpContent>
            </QcPopUpContext.Provider>
        </PolicyContextProvider>),
        dividers: true,
        onClose: handleClose,
        open: openPopup,
        title: "QC Payment Info",
    };

    return (
            <>
                {
                        openPopup &&
                        <GenericDialog {...dialogProps} />
                }
            </>
    );
};

const PopUp = (props:{epayShowRp: boolean, epaySetRp :Function }) =>{
    const { epayShowRp, epaySetRp } = props
    const { enrollmentId, setOpenPopup, refreshList, client, setSubmitting, clientPolicy, actionType } = useContext(QcPopUpContext)
    const enrollmentActions = useActions(EnrollmentActions);
    const {policy, refetchPolicy}: any = usePolicyContext();
    const {updateQCActionItem, removePaymentMethod, processPayment, rejectPayment} = useActions(PaymentActions);
    const dispatch = useDispatch();
    const updateEnrolmentStatus= async (enrollmentStatus, enrollmentSubStatus) =>{
        return  await enrollmentActions.updateEnrollment({ // need to update status and substatus, because of auto save functionality issue
            id: enrollmentId,
            enrollmentStatus,
            userId: client.userId,
            enrollmentSubStatus: enrollmentSubStatus,
            version: "v2",
        });
    }

    return <EpayRejectPayment
            epayShowRp={epayShowRp} epaySetRp={epaySetRp}
            onSubmit={async (values: any, action)=>{
                const submitting =(value)=>{
                    setSubmitting && setSubmitting(value)
                    action.setSubmitting(value);
                }
                submitting(true)
                    if(policy.paymentMethods && policy.paymentMethods[0].recordKey){
                        const removePaymentMethodPayload = {
                            policyNumber: policy.policyNumber,
                            recordKey: policy.paymentMethods && policy.paymentMethods[0].recordKey,
                        };
                       const response = await removePaymentMethod(removePaymentMethodPayload);
                        if(response.success) {
                            await updateQCActionItem({
                                status: 1,
                                type: "reject",
                                userId: client.userId,
                                message: values["message"],
                                actionType,
                                reason: rejectIngReason(values["paymentRejectedReason"], values)
                            })
                            if(actionType == "QC_EPAY_SERVICE"){
                                 await rejectPayment({ clientPolicyId: clientPolicy && clientPolicy.id, rejectionMessage: rejectIngReason(values["paymentRejectedReason"], values) });
                            }else{
                                 await updateEnrolmentStatus(3, 2);
                            }
                            await processPayment({
                                type: PaymentProcess.epay,
                                userId: client.userId,
                                clientPolicyId: policy.policyNumber,
                                reason: rejectIngReason(values["paymentRejectedReason"], values)
                            })
                        }
                    }else{
                        await updateQCActionItem({
                            status: 1,
                            type: "reject",
                            userId: client.userId,
                            message: values["message"],
                            actionType,
                            reason: rejectIngReason(values["paymentRejectedReason"], values)
                        })
                        const updateE = await updateEnrolmentStatus(3, 2)
                        await processPayment({
                            type: PaymentProcess.epay,
                            userId: client.userId,
                            clientPolicyId: policy.policyNumber,
                            reason: rejectIngReason(values["paymentRejectedReason"], values)
                        })
                    }
                    epaySetRp(false);
                    setOpenPopup && setOpenPopup(false);
                    refreshList && refreshList()
                    submitting(false)
            }}
    />
}

function rejectIngReason (reason: string, values ) {
    const selected = epayRejectedDropdown.find((value, index, obj)=>{
        return  reason == value.value
    });
    // create common for check is other selected or not
    if(selected && selected.value === "other"){
        return values["message"]
    }
    return selected && selected.name
}




